import React from 'react';
import { ResultTableTitle } from './ReportEffectExternalResults.styles';
import { useReportContext } from '../../../../hooks/useReport';
import EffectReportTemplate from '../../SharedEffectReportComponents/EffectReportTemplate/EffectReportTemplate';

const ReportEffectExternalResults = () => {
  const {
    structuredEffectData: { externalResults },
  } = useReportContext();

  return (
    <ResultTableTitle>
      {Object.values(externalResults).map(item => (
        <EffectReportTemplate key={item.type} data={item} />
      ))}
    </ResultTableTitle>
  );
};

export default ReportEffectExternalResults;
